<script>
  import { mobileFiltersOpen, searchQuery, years } from './stores'
  import Icon from '../Icon.svelte'
  import SearchInput from './SearchInput.svelte';
  import { push } from 'svelte-spa-router'
  import { beforeUpdate, tick } from 'svelte'

  let _searchQuery = ''
  let _mobileFiltersOpen = false
  let searchOpen = false
  let _years = []
  let searchInputEl = null

  $: landingUrl = `/?year=${_years.length ? _years[0].slug : ''}`

  searchQuery.subscribe((value) => { _searchQuery = value })
  years.subscribe((value) => { _years = value })
  mobileFiltersOpen.subscribe((value) => { _mobileFiltersOpen = value })

  // Search input el not available immediately, so set focus after component update
  beforeUpdate(async () => {
    await tick();
    if (searchOpen) {
      searchInputEl.focus()
    }
  });
</script>

<div class="mt-4">
  <!-- Filters and search toggle -->
  <div class={`flex items-center md:hidden space-x-4 ${searchOpen ? 'hidden' : ''}`}>
    <button
      on:click={() => {mobileFiltersOpen.set(!_mobileFiltersOpen)}} 
      class="font-display font-bold border-b-2 border-black pb-0.5 text-left w-full flex justify-between items-center"
    >
      <div class="flex space-x-2 items-center">
        <Icon name="filter"/>
        <div class="-translate-y-0.5">Refine Results</div>
      </div>
      <div class={`${_mobileFiltersOpen ? 'rotate-180' : ''}`}>
        <Icon name="chevronDown"/>
      </div>
    </button>
    <!-- Search toggle -->
    <div class="border-l-2 border-gray-300">
      <button class="pl-4" on:click={() => {searchOpen = !searchOpen}}>
        <div class="w-[18px] svg-fill">
          <Icon name="search"/>
        </div>
      </button>
    </div>
  </div>
  <!-- Search input -->
  <div class={`${searchOpen ? '' : 'hidden'} mt-3`}>
    <SearchInput
      bind:query={_searchQuery}
      bind:searchInput={searchInputEl}
      on:input={() => { 
        push(`/s/${_searchQuery}`)
        searchQuery.set(_searchQuery)
      }}
      on:close={() => {
        if (_searchQuery) {
          searchQuery.set('')
          push(landingUrl)
        }

        searchOpen = false
      }}
    />
  </div>
</div>